import makeTable from "./makeTable";
import BASE_WIDTH_COLUMNS from "./constants/baseWidthColumns";

const { ACTIVE, COMPANIES } = BASE_WIDTH_COLUMNS;

const settingsMessageTemplates = makeTable({
	allIds: [
		"allowed",
		"automaticSending",
		"name",
		"action",
		"companies",
		"taxiServices",
	],
	defaultIds: [
		"allowed",
		"automaticSending",
		"name",
		// "action",
		"companies",
		"taxiServices",
	],
	i18tPath: (id) => `settings.messages.templatesSms.columns.${id}`,
	initialSortMethod: {
		column: "name",
		type: "asc",
	},
	initialWidths: {
		allowed: ACTIVE,
		automaticSending: ACTIVE,
		name: 280,
		action: 200,
		companies: COMPANIES,
		taxiServices: 550,
	},
	initialResizable: {
		allowed: true,
		automaticSending: true,
		name: true,
		action: true,
		companies: true,
		taxiServices: true,
	},
	initialSortable: {
		allowed: true,
		automaticSending: true,
		name: true,
		action: true,
		companies: true,
		taxiServices: true,
	},
});

export default settingsMessageTemplates;
